module.exports = __webpack_public_path__ + "media/93.f7427d2f.wav";